// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1K_fm","head":"ProcedureTableInfo_head__3_z-1"};